import React, { useState } from "react";
import { Card, CardBody, CardHeader, CardFooter, Button, Input } from "@nextui-org/react";
import { BASEURL } from "../constant/constant";
import { useNavigate } from "react-router-dom";

const initialFormState = {
  personalInfo: {
    fullName: "",
    mobileNo: "",
    emailId: "",
    location: "",
    DOB: "",
    city: "",
  },
  jobDetails: {
    positionAppliedFor: "",
    noticePeriod: "",
    preferredJobLocation: "",
    expectedSalary: "",
    empType: "",
  },
  workExperience: {
    totalWorkExperience: "",
    relatedWorkExperience: "",
    lastEmployerName: "",
    companyAddress: "",
    lastJobTitle: "",
  },
  resume: null,
};
export default function ApplyNowForm() {
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 3; // Now only 3 steps


  const navigate = useNavigate();


  const [formData, setFormData] = useState({
    personalInfo: {
      fullName: "",
      mobileNo: "",
      emailId: "",
      location: "",
      DOB: "",
      city: "",
    },
    jobDetails: {
      positionAppliedFor: "",
      noticePeriod: "",
      preferredJobLocation: "",
      expectedSalary: "",
      empType: "",
    },
    workExperience: {
      totalWorkExperience: "",
      relatedWorkExperience: "",
      lastEmployerName: "",
      companyAddress: "",
      lastJobTitle: "",
    },
    resume: null,
  });

  const [showSuccess, setShowSuccess] = useState(false);

  // Handle input changes correctly for nested fields
  const handleChange = (e, section) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [section]: {
        ...prevData[section],
        [name]: value,
      },
    }));
  };

  // Handle file input separately
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // check MIME type or extension
    const isPdf =
      file.type === "application/pdf" ||
      file.name.toLowerCase().endsWith(".pdf");

    if (!isPdf) {
      alert("Only PDF files are allowed.");
      e.target.value = ""; // clear the input
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      resume: file,
    }));
  };
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSend = new FormData();

    Object.keys(formData.personalInfo).forEach((key) => {
      formDataToSend.append(`personalInfo[${key}]`, formData.personalInfo[key]);
    });

    Object.keys(formData.jobDetails).forEach((key) => {
      formDataToSend.append(`jobDetails[${key}]`, formData.jobDetails[key]);
    });

    Object.keys(formData.workExperience).forEach((key) => {
      formDataToSend.append(`workExperience[${key}]`, formData.workExperience[key]);
    });

    if (formData.resume) {
      formDataToSend.append("resume", formData.resume);
    }

    try {
      const response = await fetch(`${BASEURL}/api/applyNow/createApplication`, {
        method: "POST",
        body: formDataToSend,
      });

      if (!response.ok) {
        throw new Error("Server did not respond.");
      }

      const result = await response.json();
      console.log("Success:", result);

      // show success message
      setShowSuccess(true);

      // clear all fields and go back to step 1
      setFormData(initialFormState);
      setCurrentStep(1);

      // hide message and navigate after 7 seconds
      setTimeout(() => {
        setShowSuccess(false);
        navigate("/career"); // adjust route if different
      }, 5000);
    } catch (error) {
      console.error("API Error:", error);
      // optionally set an error toast/state here
    }
  };

  const nextStep = () => {
    if (currentStep < totalSteps) setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };
  //////////////  date desable nextand beyond date *******************************
  const getToday = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };
  const getStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <>
            <h3 className="text-md font-semibold">Personal Information</h3>
            <Input type="text" label="Full Name" name="fullName" value={formData.personalInfo.fullName} onChange={(e) => handleChange(e, "personalInfo")} isRequired />
            <Input
              type="tel"
              label="Mobile No"
              name="mobileNo"
              value={formData.personalInfo.mobileNo}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // only digits
                if (value.length <= 10) {
                  handleChange(
                    { target: { name: "mobileNo", value } },
                    "personalInfo"
                  );
                }
              }}
              isRequired
              minLength={10}
              maxLength={10}
              pattern="[0-9]{10}"
              placeholder="Enter 10-digit mobile number"
              errorMessage={
                formData.personalInfo.mobileNo &&
                  formData.personalInfo.mobileNo.length !== 10
                  ? "Mobile number must be exactly 10 digits"
                  : ""
              }
            />
            <Input type="email" label="Email ID" name="emailId" value={formData.personalInfo.emailId} onChange={(e) => handleChange(e, "personalInfo")} isRequired />
            <Input type="text" label="Location" name="location" value={formData.personalInfo.location} onChange={(e) => handleChange(e, "personalInfo")} isRequired />
            <Input
              type="date"
              label="Date of Birth"
              name="DOB"
              value={formData.personalInfo.DOB}
              onChange={(e) => handleChange(e, "personalInfo")}
              isRequired
              max={getToday()}
            />
            <Input type="text" label="City" name="city" value={formData.personalInfo.city} onChange={(e) => handleChange(e, "personalInfo")} isRequired />
          </>
        );
      case 2:
        return (
          <>
            <h3 className="text-md font-semibold">Job Details</h3>
            <Input type="text" label="Position Applied For" name="positionAppliedFor" value={formData.jobDetails.positionAppliedFor} onChange={(e) => handleChange(e, "jobDetails")} isRequired />
            <Input type="text" label="Notice Period" name="noticePeriod" value={formData.jobDetails.noticePeriod} onChange={(e) => handleChange(e, "jobDetails")} isRequired />
            <Input type="text" label="Preferred Job Location" name="preferredJobLocation" value={formData.jobDetails.preferredJobLocation} onChange={(e) => handleChange(e, "jobDetails")} isRequired />
            <Input type="text" label="Expected Salary" name="expectedSalary"
              value={formData.jobDetails.expectedSalary}
              onChange={(e) => {
                const numeric = e.target.value.replace(/\D/g, ""); // keep only digits
                handleChange(
                  { target: { name: "expectedSalary", value: numeric } },
                  "jobDetails"
                );
              }} isRequired />
            <Input type="text" label="Employment Type" name="empType" value={formData.jobDetails.empType} onChange={(e) => handleChange(e, "jobDetails")} isRequired />
          </>
        );
      case 3:
        return (
          <>
            <h3 className="text-md font-semibold">Work Experience</h3>
            <Input type="text" label="Total Work Experience" name="totalWorkExperience" value={formData.workExperience.totalWorkExperience} onChange={(e) => handleChange(e, "workExperience")} isRequired />
            <Input type="text" label="Related Work Experience" name="relatedWorkExperience" value={formData.workExperience.relatedWorkExperience} onChange={(e) => handleChange(e, "workExperience")} isRequired />
            <Input type="text" label="Last Employer Name" name="lastEmployerName" value={formData.workExperience.lastEmployerName} onChange={(e) => handleChange(e, "workExperience")} isRequired />
            <Input type="text" label="Company Address" name="companyAddress" value={formData.workExperience.companyAddress} onChange={(e) => handleChange(e, "workExperience")} isRequired />
            <Input type="text" label="Last Job Title" name="lastJobTitle" value={formData.workExperience.lastJobTitle} onChange={(e) => handleChange(e, "workExperience")} isRequired />

            {/* Resume upload now inside case 3 */}
            <h3 className="text-md font-semibold mt-3">Upload Resume</h3>
            <Input type="file" label="Resume" name="resume" accept="application/pdf" onChange={handleFileChange} isRequired />
          </>
        );
      default:
        return null;
    }
  };

  /////****************** validation in next btn desable *********************************///////
  const isCurrentStepValid = () => {
    if (currentStep === 1) {
      const p = formData.personalInfo;
      return (
        p.fullName.trim() &&
        p.mobileNo.trim().length === 10 &&
        p.emailId.trim() &&
        p.location.trim() &&
        p.DOB.trim() &&
        p.city.trim()
      );
    }

    if (currentStep === 2) {
      const j = formData.jobDetails;
      return (
        j.positionAppliedFor.trim() &&
        j.noticePeriod.trim() &&
        j.preferredJobLocation.trim() &&
        j.expectedSalary.trim() &&
        j.empType.trim()
      );
    }

    if (currentStep === 3) {
      const w = formData.workExperience;
      return (
        w.totalWorkExperience.trim() &&
        w.relatedWorkExperience.trim() &&
        w.lastEmployerName.trim() &&
        w.companyAddress.trim() &&
        w.lastJobTitle.trim() &&
        formData.resume // must be selected
      );
    }

    return false;
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <Card className="w-full max-w-lg mx-auto p-6 shadow-lg rounded-lg bg-white mt-5" style={{ marginTop: '120px' }}>
        <CardHeader className="text-lg font-bold text-center">Job Application Form</CardHeader>
        <CardBody>
          <form onSubmit={handleSubmit} className="flex flex-col gap-3">
            {getStepContent()}

            <CardFooter className="flex justify-between gap-3 pt-4">
              {currentStep > 1 && (
                <Button color="default" variant="bordered" onClick={prevStep} type="button">
                  Previous
                </Button>
              )}

              {currentStep === totalSteps ? (
                <>
                  <Button color="danger" type="reset">
                    Reset
                  </Button>
                  <Button color="primary" type="submit" disabled={!isCurrentStepValid()}>
                    Submit
                  </Button>
                </>
              ) : (
                <Button
                  color="primary"
                  onClick={nextStep}
                  type="button"
                  disabled={!isCurrentStepValid()}  // key line
                >
                  Next
                </Button>
              )}
            </CardFooter>

          </form>
        </CardBody>
      </Card>

      {/* Success message alert */}
      {showSuccess && (
        <div className="fixed top-15 right-5 bg-green-500 text-white px-5 py-3 rounded-lg shadow-lg flex items-center gap-2 transition-opacity animate-fade-in">
          ✅ Application submitted successfully! 😊 we will call you as soon as posible !!
        </div>
      )}
    </div>
  );
}
